import i18next from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";

export const createI18n = (lang: string) => {
	i18next.createInstance({

	})
	//.use(initReactI18next) // passes i18n down to react-i18next
}

export const i18n = i18next
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    resources: {
      en: {
        translation: {
					"Characters": "Characters",
          "Welcome to React": "Welcome to React and react-i18next",
        }
      },
			ru: {
        translation: {
					"Characters": "Иероглифы",
          "Welcome to React": "Привет",
        }
      },
    },
    lng: "ru",
    fallbackLng: "en",

    interpolation: {
      escapeValue: false
    }
  });